export const hasNotificationDestination = value =>
    typeof value === 'string' && value.trim() !== '';

export const telegramLinkCommands = token => ({
    direct: `/start ${ token }`,
    group: `/start@syagent_bot ${ token }`
});
